import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import Style from "../Style/CourseDetails.module.scss";
import { Helmet, HelmetProvider } from "react-helmet-async";
const baseURL = process.env.REACT_APP_BASE_URL;

const CourseDetail = ({ darkMode }) => {
  const { titleSlug } = useParams();
  const [courseList, setCourseList] = useState([]);
  const [skillTitle, setSkillTitle] = useState("");
  const [skillId, setSkillId] = useState(null);

  const formattedTitle = titleSlug
    ?.split("-")
    .map((word, index) =>
      index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word
    )
    .join(" ");
  useEffect(() => {
    axios
      .get(`${baseURL}/api/get/skills`)
      .then((res) => {
        console.log("Skills fetched:", res.data);
        const matchedSkill = res.data.find((skill) => {
          const slug = skill.title.toLowerCase().replace(/\s+/g, "-");
          return slug === titleSlug;
        });

        if (matchedSkill) {
          setSkillTitle(matchedSkill.title);
          setSkillId(matchedSkill.id);
        } else {
          setSkillTitle("Skill Not Found");
        }
      })
      .catch((err) => console.error("Error fetching skills", err));
  }, [titleSlug]);

  useEffect(() => {
    if (!skillId) return;

    axios
      .get(`${baseURL}/api/skill-details?skill_id=${skillId}`)
      .then((res) => setCourseList(res.data))
      .catch((err) => console.error("Error fetching course details", err));
  }, [skillId]);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>{formattedTitle}</title>
          <link rel="canonical" href={`/${titleSlug}`} />
        </Helmet>
      </HelmetProvider>
      <div className={`${Style.CourseDetail} ${darkMode ? Style.dark : ""}`}>
        <div className={Style.CourseDetailDisk}>
          <h1>{skillTitle}</h1>
          <Link to="/">Home</Link>
        </div>

        <div className={Style.wrapper}>
          <div className={Style.CourseList}>
            {courseList.length === 0 ? (
              <p>No courses found.</p>
            ) : (
              <>
                <h2 className={Style.CourseListHeading}>{skillTitle}</h2>
                <div className={Style.CourseGrid}>
                  {courseList.map((course) => (
                    <div key={course.id} className={Style.CourseCard}>
                      <div className={Style.CourseCardBox}>
                        <Link to={`/courses-more/${course.id}`}>
                          <p>{course.course}</p>
                          Know More →
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
          <div className={Style.CourseDetailEnroll}>
            <Link to="/enroll">Enroll Here</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default CourseDetail;
